import React from 'react';
import styled from 'styled-components';
export default function FormBlock({ children, className, }) {
    return (React.createElement(StyledFormBlock, { className: className }, children));
}
const StyledFormBlock = styled.div `
  padding: 12px 0px;
  min-height: 30px;
  display: flex;
  flex-direction: column;
`;
